import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import * as constants from '../common/constants';
import * as JspUtil from '../common/JspUtil';
import * as loginactions from '../loginpages/actionCreators';
import LoginTemplate from '../loginpages/LoginTemplate';
import { useJspVariables, useAppContext, useDebugRender } from '../hooks';
import { IceIcon, PageContainer } from '../components';
import Alert from '@mui/material/Alert';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

const PageRegisterLogin = () => {
    useDebugRender('PageRegisterLogin');
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { panelStyle, launcher, jspVariables } = useJspVariables();
    const { getLabelFromJspVariables, getApp } = useAppContext(jspVariables);
    const [alert, setAlert] = useState(null);

    const authenticate = async (formValues) => {
        setAlert(null);
        // Mirror the two identity rewrites authAndSendCodeTo2FAEmail applies, so the email
        // verification calls on the next page authenticate as the same user.
        const userName = formValues.mersOrganization && formValues.userName.indexOf('@') === -1
            ? formValues.mersOrganization + '_' + formValues.userName
            : formValues.userName;
        const appKey = userName.indexOf('@') !== -1 ? constants.APP_KEY_GLOBAL : getApp();
        try {
            const resp = await loginactions.authAndSendCodeTo2FAEmail(
                formValues.userName, getApp(), formValues.password,
                { tfaPasscode: formValues.tfaPasscode, mersOrganization: formValues.mersOrganization, rememberMe: formValues.rememberMe });
            if (JspUtil.isValueAvailable(resp.data.userMessage)) {
                setAlert({ message: resp.data.userMessage, severity: 'success' });
            }
            dispatch({ type: loginactions.TFA_STATE, data: { required: false } });
            dispatch({ type: loginactions.GLOBAL_ID_TRANSITION, data: loginactions.GLOBAL_ID_TRANSITION_CLEAR });
            // LoginTemplate skips its own SAVED_AUTH_PARAM dispatch when onFormSubmit is set,
            // and this flow never calls getTfaDetails, so PageTfaEmailRegister has no other
            // source for the credentials it needs to send the verification code.
            dispatch({
                type: loginactions.SAVED_AUTH_PARAM,
                data: loginactions.saveAuthParam(userName, appKey, getApp(), formValues.password,
                    formValues.passwordLessOtp, formValues.captchaResponse, formValues.tfaPasscode,
                    formValues.mersOrganization, formValues.rememberMe)
            });
            navigate(constants.ROUTE_PAGE_TFA_EMAIL_REGISTER);
        } catch (resp) {
            if (resp.message) {
                setAlert({ message: resp.message, severity: 'error' });
            }
        }
    };

    return (
        <PageContainer id="pageRegisterLogin" dataAutomationId="page_register_login">
            <Box style={panelStyle}>
                <IceIcon launcher={launcher} />
                <Box className="help-notes">
                    <Typography variant="body2">
                        {getLabelFromJspVariables('login_to_register_tfa')}
                    </Typography>
                </Box>
                {alert && <Alert id="pageRegisterLoginAlert" data-automation-id="page_register_login_alert" severity={alert.severity} sx={{ mb: 1 }} onClose={() => setAlert(null)}>{alert.message}</Alert>}
                <LoginTemplate onFormSubmit={authenticate} />
            </Box>
        </PageContainer>
    );
};

export default PageRegisterLogin;
